import {Component, OnInit} from '@angular/core';
import {NbDialogService} from '@nebular/theme';
import {DeactivateDialogComponent} from './deactivate-dialog/deactivate-dialog.component';
import {SellerDeactivationComponent} from './seller-deactivation-dialog/seller-deactivation.component';
import {IntegrationChangeLogComponent} from './integration-change-log-dialog/integration-change-log.component';
import {StoreService} from '../../../../core/src/lib/store/store.service';
import {ApiService} from '../../../../core/src/lib/api/api.service';
import {FormArray, FormControl, FormGroup, Validators} from '@angular/forms';
import { APISeller } from "../../../../core/src/lib/api/api.types";
import { Router } from "@angular/router";

@Component({
  selector: 'ngx-settings',
  styleUrls: ['./settings.component.scss'],
  templateUrl: './settings.component.html',
})
export class SettingsComponent implements OnInit{
  private alive = true;
  active = true;
  isAdmin = true;
  seller!: APISeller;

  oloIntegrationForm = new FormGroup({
    clientSecret: new FormControl('', [Validators.required]),
    opsCredentials: new FormArray([]),
    active: new FormControl(false)
  })

  autoCloseFormControl = new FormControl(false)

  private oloIntegrationID?: number

  // Organization data
  orgDetails: any = null;
  memberMerchants: any[] = [];
  parentMerchant: any = null;

  constructor(
    private dialogService: NbDialogService,
    public store: StoreService,
    private api: ApiService,
    private router: Router
  ) {}

  ngOnInit() {
    this.store.user$.subscribe(user => {
if (user) {
        this.isAdmin = user.role.permissionLevel >= 2;
      }
    })
    this.store.seller$.subscribe(seller => {
      if (seller) {
        this.seller = seller;
        this.autoCloseFormControl = new FormControl(this.seller.autoCloseOrdersAfterClose || false)
        this.autoCloseFormControl.valueChanges.subscribe((value: boolean) => {
          this.store.updateSeller(this.seller.id, this.seller.name, this.seller.adminID, value).subscribe()
        })
        this.loadOrganizationData(seller.id);
      } else {
        this.router.navigate(['pages', 'manage-sellers']);
      }
    })

    this.store.oloIntegration$.subscribe(oloIntegration => {
      if (oloIntegration) {
        this.oloIntegrationID = oloIntegration.id
        this.oloIntegrationForm.patchValue({
          clientSecret: oloIntegration.clientSecret,
          active: oloIntegration.active,
        })
        
        this.opsCredentials.clear();
        if (oloIntegration.opsCredentials && Array.isArray(oloIntegration.opsCredentials)) {
          oloIntegration.opsCredentials.forEach((credential: any) => {
            this.addCredential(credential.name, credential.opsClientID, credential.opsClientSecret);
          });
        }
      }
    })

  }

  saveChanges(event: Event) {
    event.stopPropagation();
    if (!this.oloActive?.value) {
      const dialogRef = this.dialogService.open(DeactivateDialogComponent, {
        context: {
          title: 'Deactivate Integration',
          sellerName: this.seller.name,
        },
      });
      dialogRef.componentRef.instance.deactivate.subscribe(() => {
        this.store.updateOloIntegration(this.oloIntegrationForm.value, this.seller.id).subscribe();
      })
    } else {
      this.store.updateOloIntegration(this.oloIntegrationForm.value, this.seller.id).subscribe();
    }
  }

  sellerRequestDeactivation(event: Event) {
    event.stopPropagation();
    const dialogRef = this.dialogService.open(SellerDeactivationComponent, {
      context: {
        title: 'Deactivate Integration',
        sellerName: this.seller.name
      },
    });
    dialogRef.componentRef.instance.deactivate.subscribe(() => {
      this.store.requestIntegrationShutoff('olo', this.seller.id).subscribe();
    })
  }

  changeLog(event: Event) {
    event.stopPropagation();
    this.dialogService.open(IntegrationChangeLogComponent, {
      context: {
        title: 'Integration Changelog',
        integrationId: this.oloIntegrationID
      },
    });
  }

  get oloClientSecret() {
    return this.oloIntegrationForm.get('clientSecret');
  }

  get oloActive() {
    return this.oloIntegrationForm.get('active');
  }

  get opsCredentials() {
    return this.oloIntegrationForm.get('opsCredentials') as FormArray;
  }

  addCredential(name: string = '', id: string = '', secret: string = '') {
    this.opsCredentials.push(new FormGroup({
      name: new FormControl(name, [Validators.required]),
      opsClientID: new FormControl(id, [Validators.required]),
      opsClientSecret: new FormControl(secret, [Validators.required])
    }));
  }

  removeCredential(index: number) {
    this.opsCredentials.removeAt(index);
  }

  private loadOrganizationData(sellerID: number) {
    this.orgDetails = null;
    this.memberMerchants = [];
    this.parentMerchant = null;

    this.api.getOrganizationDetails(sellerID).subscribe({
      next: (details) => {
        this.orgDetails = details;
        if (details?.isOperatingMerchant) {
          this.api.getMemberMerchants(sellerID).subscribe({
            next: (res) => this.memberMerchants = res?.members || [],
          });
        }
        if (details && !details.isOperatingMerchant && details.organizationId) {
          this.api.getOperatingMerchant(sellerID).subscribe({
            next: (parent) => this.parentMerchant = parent,
          });
        }
      },
    });
  }

  viewParent() {
    if (this.parentMerchant) {
      this.store.setSeller(this.parentMerchant);
      this.router.navigate(['pages', 'settings']);
    }
  }

  viewMember(member: any) {
    this.store.setSeller(member);
    this.router.navigate(['pages', 'settings']);
  }

  viewOrganizationDetails() {
    this.router.navigate(['pages', 'organization-details']);
  }

  hasExtRef(locations: any[]): boolean {
    return locations?.some(loc => loc.extRef && loc.extRef !== '0') || false;
  }

}
